import React, { useEffect, useState } from "react";
import "./Header.css";
import logo from "../assets/wellingtonia_logo_nobg.png";

export default function Header({ scrollToSection, activeSection }) {
  const [isMobileView, setIsMobileView] = useState(false);
  const [isMobileMenu, setIsMobileMenu] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 972) {
      setIsMobileView(true);
      setIsMobileMenu(false);
    } else {
      setIsMobileView(false);
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth < 972) {
        setIsMobileView(true);
        setIsMobileMenu(false);
      } else {
        setIsMobileView(false);
      }
    });
  }, []);

  return (
    <header className={`header`}>
      <div to={"/"} className="logo">
        <img
          src={logo}
          className={`logo-img ${isMobileView && "mobile"}`}
          alt="vibes&vent logo"
        />
      </div>

      {isMobileView ? (
        <div onClick={() => setIsMobileMenu((current) => (current = !current))}>
          Menu
        </div>
      ) : (
        <>
          <nav className="nav">
            <div
              className={
                activeSection === "hero" ? "nav-option active" : "nav-option"
              }
              onClick={() => scrollToSection("hero")}
            >
              Home
            </div>
            <div
              className={
                activeSection === "about" ? "nav-option active" : "nav-option"
              }
              onClick={() => scrollToSection("about")}
            >
              About
            </div>
            <div
              className={
                activeSection === "why-us" ? "nav-option active" : "nav-option"
              }
              onClick={() => scrollToSection("why-us")}
            >
              Why SIS
            </div>
            <div
              className={
                activeSection === "what-we-do"
                  ? "nav-option active"
                  : "nav-option"
              }
              onClick={() => scrollToSection("what-we-do")}
            >
              Academic
            </div>

            <div
              className={
                activeSection === "contact" ? "nav-option active" : "nav-option"
              }
              onClick={() => scrollToSection("contact")}
            >
              Contact
            </div>
          </nav>
        </>
      )}
      {isMobileMenu && isMobileView && (
        <nav className="nav mobile">
          <div className="nav-option" onClick={() => scrollToSection("hero")}>
            Home
          </div>
          <div className="nav-option" onClick={() => scrollToSection("about")}>
            About
          </div>
          <div className="nav-option" onClick={() => scrollToSection("why-us")}>
            Why us
          </div>
          <div
            className="nav-option"
            onClick={() => scrollToSection("how-it-works")}
          >
            How it works
          </div>
          <div className="nav-option" onClick={() => scrollToSection("faq")}>
            FAQs
          </div>
        </nav>
      )}
    </header>
  );
}
